import { uniqueId } from "lodash";
import React from "react";
import PropTypes from "prop-types";
import Alert from "antd/lib/alert";
import Button from "antd/lib/button";
import Checkbox from "antd/lib/checkbox";
import Form from "antd/lib/form";
import InputNumber from "antd/lib/input-number";
import Modal from "antd/lib/modal";
import { wrap as wrapDialog, DialogPropType } from "@/components/dialog-wrapper/DialogWrapper";
import { clientConfig } from "@/services/auth";
import CodeBlock from "@/components/code-block/CodeBlock";
import { useTheme } from "@/components/ThemeProvider";

import "./EmbedQueryDialog.less";

function EmbedQueryDialog({ dialog, query, visualization }) {
  const { isDarkMode } = useTheme();
  const [enableChangeIframeSize, setEnableChangeIframeSize] = React.useState(false);
  const [iframeWidth, setIframeWidth] = React.useState(720);
  const [iframeHeight, setIframeHeight] = React.useState(391);

  const embedUrl = `${clientConfig.basePath}embed/query/${query.id}/visualization/${visualization.id}?api_key=${
    query.api_key
  }&${query.getParameters().toUrlParams()}`;

  const snapshotUrl = window.snapshotUrlBuilder ? window.snapshotUrlBuilder(query, visualization) : null;

  const urlEmbedLabelId = uniqueId('url-embed-label-');
  const iframeEmbedLabelId = uniqueId('iframe-embed-label-');

  return (
    <Modal
      {...dialog.props}
      className={`embed-query-dialog ${isDarkMode ? 'dark-mode' : ''}`}
      title="Embed Query"
      footer={<Button onClick={dialog.dismiss}>Close</Button>}>
      {query.is_safe ? (
        <React.Fragment>
          <h5 id={urlEmbedLabelId} className="m-t-0">
            Public URL
          </h5>
          <div className="m-b-30">
            <CodeBlock aria-labelledby={urlEmbedLabelId} data-test="EmbedIframe" copyable>
              {embedUrl}
            </CodeBlock>
          </div>
          <h5 id={iframeEmbedLabelId} className="m-t-0">
            IFrame Embed
          </h5>
          <div>
            <CodeBlock aria-labelledby={iframeEmbedLabelId} copyable>
              {`<iframe src="${embedUrl}" width="${iframeWidth}" height="${iframeHeight}"></iframe>`}
            </CodeBlock>
            <Form className="m-t-10" layout="inline">
              <Form.Item>
                <Checkbox
                  checked={enableChangeIframeSize}
                  onChange={e => setEnableChangeIframeSize(e.target.checked)}
                />
              </Form.Item>
              <Form.Item label="Width">
                <InputNumber
                  className="size-input"
                  value={iframeWidth}
                  onChange={value => setIframeWidth(value)}
                  size="small"
                  disabled={!enableChangeIframeSize}
                />
              </Form.Item>
              <Form.Item label="Height">
                <InputNumber
                  className="size-input"
                  value={iframeHeight}
                  onChange={value => setIframeHeight(value)}
                  size="small"
                  disabled={!enableChangeIframeSize}
                />
              </Form.Item>
            </Form>
          </div>
          {snapshotUrl && (
            <React.Fragment>
              <h5>Image Embed</h5>
              <CodeBlock copyable>{snapshotUrl}</CodeBlock>
            </React.Fragment>
          )}
        </React.Fragment>
      ) : (
        <Alert
          message="Currently it is not possible to embed queries that contain text parameters."
          type="error"
          data-test="EmbedErrorAlert"
        />
      )}
    </Modal>
  );
}

EmbedQueryDialog.propTypes = {
  dialog: DialogPropType.isRequired,
  query: PropTypes.object.isRequired,
  visualization: PropTypes.object.isRequired,
};

export default wrapDialog(EmbedQueryDialog);